/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
import { topLevelElementCss } from '.';
export const createHeading = (depth) => {
    const htmlTag = `h${depth}`;
    const Heading = React.forwardRef((props, ref) => {
        const theme = useTheme();
        return jsx(htmlTag, {
            ...props,
            ref,
            css: [
                topLevelElementCss,
                {
                    margin: '0.2em 0 0.2em 30px',
                    color: theme.colors.heading.text,
                    caretColor: theme.colors.heading.text,
                },
            ],
        });
    });
    Heading.displayName = `H${depth}`;
    return React.memo(Heading);
};
//# sourceMappingURL=headings.js.map